export default "__VITE_ASSET__CE6Nbrc___"